<template>
    <div class="float-left">
        <b-button
            variant="success"
            @click="abrirModal()"
            v-if="convenio.idSituacaoConvenio != 9"
            >Adicionar
        </b-button>
        <projeto-acao-form
            operacaoProp="I"
            :comprometimento="comprometimento"
            :convenio = "convenio"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></projeto-acao-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import ProjetoAcaoForm from './ProjetoAcaoForm.vue'

export default {
    components: {
        ProjetoAcaoForm,
        desativarBotao: Boolean
    },

    props: {
        convenio: Object,
    },

    data() {
        return {
            mostrarModal: false,
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            erros: [],
            comprometimento: {
                idRateioComprometimento:0,
                idCronogramaDesembolso:0,
                codCCusto: null,
                nuValorRateio:0,
            },
            // unidades: [],
            // projetos: [],
            // acoes: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true;      
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(comprometimento){
            this.$store.dispatch('addRequest')
            let comprometimentoDto = {
                idConvenio : this.convenio.idConvenio,
                idRateioComprometimento: comprometimento.idRateioComprometimento,
                idCronogramaDesembolso:comprometimento.idCronogramaDesembolso,
                nuValorRateio:comprometimento.nuValorRateio,
                codCCusto: comprometimento.codCCusto,
                nomeCCusto: comprometimento.nomeCCusto
            }
            ConveniosServicos.inserirRateioComprometimento(comprometimentoDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Comprometimento inserido com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarListaComprometimentos')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    }
}
</script>
